import { Select2Helper } from "../../Helpers/Select2Helper";
import { StringHelper } from "../../Helpers/StringHelper";

export class AddManualProjectManager {

    constructor(private containerElement: JQuery) { }

    private linesTable : JQuery<HTMLElement>;
    private linesTableBody : JQuery<HTMLElement>;
    private addLineButton : JQuery<HTMLElement>;

    private templateElement : JQuery<HTMLElement>;


    public initialize() {
        this.bindElements();
        this.bindEvents();
    }

    private bindElements() {
        var self = this;

        this.linesTable = this.containerElement.find('#lines-table');
        this.linesTableBody = this.linesTable.find('tbody');
        this.addLineButton = this.containerElement.find('#add-line-button');

        this.templateElement = this.containerElement.find('#doc-detail-row');

        StringHelper.bindNumberStringInputs();

        self.containerElement.find('select.select2').each((index, element) => {
            var selectElement = $(element);
            Select2Helper.BindSelect2Input(selectElement);
        });
    }

    private bindEvents() {
        var self = this;

        self.addLineButton.off('click').on('click', () => {
            var newListItem = $(self.templateElement.html());

            this.bindLineOfBusinessRow(newListItem);
    
            self.linesTableBody.append(newListItem);

            StringHelper.bindNumberStringInputs();
        });

        self.linesTableBody.find('tr').each((index, element) => {
            var listItemRow = $(element);
            self.bindLineOfBusinessRow(listItemRow);
        }) 

        var form =  this.containerElement.find('form');
        var submitButton = form.find(':submit');

        submitButton.off('click').on('click', (e) => {
            e.preventDefault();
            e.stopImmediatePropagation();

            submitButton.prop('disabled', true);

            var isValid = true;

            self.linesTableBody.find('tr').each((rowIndex, rowElement) => {
                var row = $(rowElement);
                row.find('[data-set-name]').each((index, nameInput) => {
                    var parsedNameInput = $(nameInput);
                    var nameToSet : string = parsedNameInput.data('set-name').toString();
                    parsedNameInput.prop('name', nameToSet.replace('<I>', `${rowIndex}`))

                    if(!row.hasClass('d-none') && parsedNameInput.is('input:text')) {
                        var value = parsedNameInput.val();
                        if(value == undefined || value == '') {
                            isValid = false;
                            parsedNameInput.addClass('is-invalid');
                        }
                    }
                })
            })

            if(isValid) {
                form.trigger('submit');
            }
            else {
                submitButton.prop('disabled', false);
            }
        }) 
    }

    private bindLineOfBusinessRow(row : JQuery<Element>) {
        var self = this;

        // var englishValueInput = row.find('#english-value-input');
        // var spanishValueInput = row.find('#spanish-value-input');
        // var hiddenDeletedInout = row.find('#hidden-deleted-input');

        // englishValueInput.on('keyup', () => {
        //     var value = englishValueInput.val();
        //     if(value == undefined || value == '') {
        //         englishValueInput.addClass('is-invalid');
        //     }
        //     else {
        //         englishValueInput.removeClass('is-invalid');
        //     }
        // });

        // spanishValueInput.on('keyup', () => {
        //     var value = spanishValueInput.val();
        //     if(value == undefined || value == '') {
        //         spanishValueInput.addClass('is-invalid');
        //     }
        //     else {
        //         spanishValueInput.removeClass('is-invalid');
        //     }
        // });

        var removeButton = row.find('#remove-button');
        removeButton.off('click').on('click', () => {
            row.remove();

            // englishValueInput.prop('required', false);
            // spanishValueInput.prop('required', false);

            // hiddenDeletedInout.val('true');
        });

    }
}